import React, { useState, useEffect } from "react";
import {
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
    Select,
    Menu,
    FormControlLabel,
    MenuItem,
    Checkbox,
} from "@material-ui/core";

const MultiControlledTemplateSelect = ({
    label,
    id,
    value,
    options,
    onChange,
    hasError,
    isRequired
}) => {
    const [localValue, setLocalValue] = useState(
        Array.isArray(value) ? value : [],
    );
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        setLocalValue(value || []);
    }, [value]);

    const handleChange = (newValue) => {
        setLocalValue(newValue);
        onChange({ target: { name: id, value: newValue } });
    };

    const toggleCheckbox = (option) => {
        let newValue;
        if (["ALL", "DEFAULT"].includes(option.name)) {
            newValue = [option];
            handleChange(newValue);
            return;
        }
        const isSelected = localValue.some((item) => item.id === option.id);
        newValue = isSelected
            ? localValue.filter((item) => item.id !== option.id)
            : [...localValue, option];

        newValue = newValue.filter(
            (item) => !["ALL", "DEFAULT"].includes(item.name),
        );

        if (newValue.length === 0 && isRequired) {
            alert("At least one element must be selected!");
            return;
        }
        handleChange(newValue);
    };

    const isOptionChecked = (option) => {
        return localValue.some((item) => item.id === option.id);
    };

    const renderValue = (selected) => {
        if (!Array.isArray(selected) || selected.length === 0) {
            return "";
        }
        return selected
            .map((item) => options.find((opt) => opt.id === item.id)?.name)
            .join(", ");
    };

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel>{label} <span style={{color: "red"}}>{isRequired ? "*" : ""}</span></InputLabel>
                <Select
                    name={id}
                    multiple
                    value={localValue}
                    required={isRequired}
                    label={label}
                    renderValue={renderValue}
                    onOpen={(event) => setAnchorEl(event.target)}
                    onClose={() => setAnchorEl(null)}
                    open={Boolean(anchorEl)}
                >
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        style={{ marginTop: "-2px" }}
                    >
                        {options?.map((option) => {
                            return (
                                <MenuItem
                                    key={option.id}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isOptionChecked(
                                                    option,
                                                )}
                                                onChange={() =>
                                                    toggleCheckbox(option)
                                                }
                                            />
                                        }
                                        label={option.name}
                                    />
                                </MenuItem>
                            );
                        })}
                    </Menu>
                </Select>
                {hasError && (
                    <FormHelperText style={{ color: "red" }}>
                        This is required!
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    );
};

export default MultiControlledTemplateSelect;
